import { useState } from 'react';
import { type UseDisableHookResult } from '@saviynt/biz-entity-catalog';

import { updateClient } from '../data-sources';

/**
 * BizEntityCatalog disable hook adapter for client credentials.
 * Sends PUT with enabled: false to the single update endpoint.
 */
export function useClientDisable(): UseDisableHookResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const mutate = async (id: string | number): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      await updateClient(String(id), { enabled: false });
    } catch (err) {
      const typedError = err instanceof Error ? err : new Error(String(err));

      setError(typedError);
      throw typedError;
    } finally {
      setIsLoading(false);
    }
  };

  return { mutate, isLoading, error };
}
